<div class="container-fluid">


  <div class="insurance-content-no-style" style="margin-top: 32px!important">
    <form [formGroup]="searchForm">

      <div class="row margin-top-8">
        <div class="col-md-4 label right">{{ 'insurance.search_country' | translate}}:</div>
        <div class="col-md-4">
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon"><i class="fa fa-flag"></i></span>
            <p-dropdown [options]="countries" formControlName="Country"
                        placeholder="{{ 'insurance.search_country' | translate}}">
              <ng-template let-country pTemplate="country">
                <img src="/assets/flags/1x1/{{country.flag}}" style="width:20px;vertical-align:middle"/>
                <span style="margin-left:.25em">{{country.label}}</span>
              </ng-template>
            </p-dropdown>
          </div>
        </div>
      </div>

      <div class="row margin-top-8">
        <div class="col-md-4 label right">{{ 'insurance.area' | translate}}:</div>
        <div class="col-md-4">
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon"><i class="fa fa-map"></i></span>
            <input type="text" pInputText formControlName="Area" placeholder="{{ 'insurance.area' | translate }}"/>
          </div>
        </div>
      </div>

      <div class="row margin-top-16">
        <div class="col-md-4 label right">{{ 'insurance.radius' | translate}}:</div>
        <div class="col-md-3">
          <div class="margin-top-8">
            <p-slider [max]="5000" [min]="30" [step]="10" [(ngModel)]="Radius" [ngModelOptions]="{standalone: true}">
            </p-slider>
          </div>
        </div>
        <div class="col-md-2 label">{{ Radius + ' km Radius' }}</div>
      </div>

      <!--<div class="row margin-top-8">
        <div class="col-md-4 label right">{{ 'insurance.select_a_brand' | translate}}:</div>
        <div class="col-md-4">
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon"><i class="fa fa-cube"></i></span>
            <p-dropdown [options]="brands" formControlName="Brand"
              placeholder="{{ 'insurance.select_a_brand' | translate}}">
              <ng-template let-brand pTemplate="brand">
                <span style="margin-left:.25em">{{brand.label}}</span>
              </ng-template>
            </p-dropdown>
          </div>
        </div>
      </div>-->

      <div class="row margin-top-8">
        <div class="col-md-4 label right">{{ 'general.search' | translate}}:</div>
        <div class="col-md-4">
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon"><i class="fa fa-search"></i></span>
            <p-autoComplete formControlName="Search" [suggestions]="bikeResults"
                            placeholder="{{ 'insurance.search_bike'| translate }}"
                            (completeMethod)="searchBikes($event)"
                            (onSelect)="bikeSelected($event)" [forceSelection]="false" [minLength]="4" [delay]="1000">
            </p-autoComplete>
          </div>
        </div>
      </div>

      <div class="row margin-top-8">
        <div class="col-md-4 label right">{{ 'insurance.show_records_with_qty' | translate}}:</div>
        <div class="col-md-4">
          <div class="p-inputgroup">
            <p-checkbox formControlName="ShowStockRecordsOnly" [binary]="true"></p-checkbox>
          </div>
        </div>
      </div>

      <div class="row margin-top-32">
        <div class="col-lg-6 col-md-5"></div>
        <div class="col-lg-2 col-md-3">
          <button pButton class="full-width"
                  label="{{loading ? ('insurance.please_wait' | translate) : ('insurance.search_bike_shops' | translate)}}"
                  (click)="searchStores()" [disabled]="!searchForm.valid || loading"></button>
        </div>
      </div>
    </form>
  </div>

  <div class="insurance-content" style="margin-top: 32px!important" *ngIf="!loading && searchComplete">
    <div class="header-container">
      <div
        class="page-header">{{ 'insurance.search_results' | translate }} {{searchResults && searchResults.length > 0 ? (' - ' + searchResults.length + ' Matching Items') : ''}}</div>
    </div>

    <div *ngIf="!loading && searchComplete && searchResults.length===0">
      There are no results for this search query. If you have the radius low, try make it larger to search a larger
      region.
    </div>

    <div class="search-result-container">
      <div *ngFor="let result of searchResults" class="search-result">
        <div class="shop-name">{{result.PartnerName}}</div>
        <div><span class="fa fa-phone"></span>{{result.PhoneNumber}}</div>
        <div><span class="fa fa-envelope-o"></span>{{result.EmailAddress}}</div>
        <div><span class="fa fa-map-marker"></span>{{result.PhysicalAddress}}</div>
        <div class="divider"></div>
        <div class="product">{{result.Product.ProductName}}</div>
        <div style="display: block;">
          <div class="row">
            <div class="col-md-6 label">{{'insurance.SKU' | translate}}</div>
            <div class="col-md-6 label right">{{result.Product.SKU}}</div>
          </div>
          <div class="row">
            <div class="col-md-6 label">{{'insurance.price' | translate}}</div>
            <div
              class="col-md-6 label right">{{result.Product.CurrencySymbol}} {{result.Product.Price | number : '.2-2'}}</div>
          </div>
          <div class="row">
            <div class="col-md-6 label">{{'insurance.quantity_in_stock' | translate}}</div>
            <div class="col-md-6 label right">{{result.Product.Quantity | number}}</div>
          </div>
          <!--<div class="row">
            <div class="col-md-6 label">{{'insurance.size' | translate}}</div>
            <div class="col-md-6 label right">{{result.Product.FrameSize}}</div>
          </div>
          <div class="row">
            <div class="col-md-6 label">{{'insurance.color' | translate}}</div>
            <div class="col-md-6 label right">{{result.Product.Color }}</div>
          </div>-->
        </div>
      </div>
    </div>
  </div>

</div>
